import "../pages/film/details.js"
import "../pages/film/trailer-modal.js"